import { createSelector } from '@reduxjs/toolkit';

import {
  prevProjectMappingsSelector,
  projectMappingsSelector,
} from 'src/selectors/projectMappings';

export const projectMappingSelector = (
  projectId: string,
  mappingId: string | undefined
) =>
  createSelector(
    projectMappingsSelector(projectId),
    (mappings) =>
      (mappingId && mappings.find((mapping) => mapping.value === mappingId)) ||
      null
  );

export const prevProjectMappingSelector = (
  projectId: string,
  mappingId: string | undefined
) =>
  createSelector(
    prevProjectMappingsSelector(projectId),
    (mappings) =>
      (mappingId && mappings.find((mapping) => mapping.value === mappingId)) ||
      null
  );
